import { Typography } from 'antd';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { WidgetLoader } from 'datastake-daf/dist/components';
import Tooltip from './BasicTooltip';
import Chart from '../../../../../../screens/Analysis/sca-dds-kyc-widgets/information-availability/chart';

const { Paragraph } = Typography;

const DDUptake = ({ data, loading = true }) => {
  const { t } = useTranslation();
  const [active, setActive] = useState(null)

  const _renderTooltip = ({ mouseX, mouseY }) => {
    const label = t(active === 'COMBINED' ? 'Assessed Participants' : 'Reporting Participants');
    const _value = active === 'COMBINED' ? data?.percentage?.assessed * 100 : data?.percentage?.reporting * 100;
    const val = Number.isNaN(_value) ? 0 : _value;
    const value = active === 'COMBINED' ? `${Number(val).toFixed(0)}%` : `${Number(val).toFixed(0)}%`;


    return (
      <Tooltip
        mouseY={mouseY}
        mouseX={mouseX}
        label={label}
        value={value}
      />
    )
  }

  return (
    <div className="cont">
      <div className="h4-cont">
        <Paragraph className="h4" ellipsis={{ rows: 2, tooltip: t('Due Diligence Uptake') }}>
          {t('Due Diligence Uptake')}
        </Paragraph>
      </div>
      <div className="chart-cont">
        {loading && <WidgetLoader background="white" />}
        <Chart
          dataA={data?.percentage?.assessed || 0}
          dataB={data?.percentage?.reporting || 0}
          doConstrainsts={false}
          xDiff={10}
          yDiff={10}
          doOpacity={false}
          active={active}
          setActive={setActive}
          renderTooltip={_renderTooltip}
          mainColor="#2E90FA"
          secondColor="red"
          svgBackground="conic-gradient(from 90deg, #CF1322, #FF4D4F, #FA8C16, #FADB14, #73D13D)"
        >
        </Chart>
      </div>
      <div className="p-cont">
        <p>
          {t('Share of supply chain participants engaged in the due diligence process')}
        </p>
      </div>
    </div>
  );
};

export default DDUptake;
